<template>
  <div class="sitemap">
    <div class="container">
      <h1 class="sitemap__title">Карта сайта</h1>
      <VTabsMTS>
        <VTabMTS
          v-for="(section, idxSection) in sectionsList"
          :key="idxSection"
          :name="section.name"
          :selected="idxSection === 0"
        >
          <ul class="sitemap__content-list">
            <li
              v-for="(item, idxItem) in section.itemsList"
              :key="idxItem"
              class="sitemap__content-list-item"
            >
              <a :href="item.link">{{ item.name }}</a>
            </li>
          </ul>
        </VTabMTS>
      </VTabsMTS>
    </div>
  </div>
</template>
<script>
import VTabMTS from '~/components/Common/MTS/VTabMTS.vue'
import VTabsMTS from '~/components/Common/MTS/VTabsMTS.vue'
import SitemapMixin from '~/components/Page/Sitemap/mixins/SitemapMixin'

export default {
  name: 'SitemapMobile',
  components: {
    VTabMTS,
    VTabsMTS,
  },
  mixins: [SitemapMixin],
}
</script>
<style lang="scss" scoped>
.sitemap {
  font-family: $font-mts-compact;
  color: $color-dark-2;
  min-height: 100vh;
  padding: 32px 0 53px;

  .container {
    padding-left: 20px;
    padding-right: 20px;
  }

  &__title {
    padding-bottom: 20px;
    font-size: 36px;
    font-weight: 500;
    line-height: 40px;
  }
  &__content-list {
    list-style: none;
    margin: 0;
    position: relative;
    display: grid;
    gap: 8px;
    &-item {
      a {
        font-size: 20px;
        line-height: 38px;
        font-weight: 400;
        text-decoration: underline;
        color: $color-gray-1;
      }
    }
  }
}
</style>
